export default "__VITE_ASSET__CkA_3Fdy__"